import { useContext } from "react";

type ContextTuple<T = any> = [React.Context<any>, any]
type PContext = React.Context<any> | ContextTuple | React.ComponentType;

export const ProvideContexts: React.SFC<{ contexts: PContext[] }> = ({ contexts, children }) => {
    let lastChild: any = children;
    for (let Ent of contexts.reverse()) {
        if (Array.isArray(Ent)) {
            const [context, value] = Ent;
            lastChild = <context.Provider value={value} children={lastChild} />
        } else if ('Provider' in Ent) {
            lastChild = <Ent.Provider value={undefined} children={lastChild} />
        } else {
            lastChild = <Ent children={lastChild} />
        }
    }
    return lastChild;
}

interface InjectContextsProps {
    contexts: { [k: string]: React.Context<any> };
    children: (contexts: {[k: string]: any}) => React.ReactElement;
}

export const InjectContexts: React.SFC<InjectContextsProps> = ({ contexts, children }) => {
    const resolvedContexts = {};
    for (let [k, ctx] of Object.entries(contexts)) {
        resolvedContexts[k] = useContext(ctx);
    }
    return children(resolvedContexts);
}
